
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Router from 'vue-router'

Vue.use(VueRouter);

// component
import Login from "@/components/authentication/login"
import Home from "@/pages/site/Home";
import Product from "@/pages/site/Product";
import ProductPdfGenearation from "@/pages/site/ProductPdfGenearation";
import Aboutus from "@/pages/site/About-us"

import AddProduct from "@/pages/admin/Product";
import ProductList from "@/components/admin/Product-list"
import EditProduct from "@/pages/admin/Edit-Product"
import AddCategory from "@/components/admin/Add-Category"
import AddSubCategory from "@/components/admin/Add-SubCategory"
import AddBrands from "@/components/admin/Add-Brands"
import AdminDashboard from "@/pages/admin/admin-dashboard"

import _404 from "@/pages/404";

let router = new VueRouter({
    routes:[
     
      {
          path: '/',
          name: 'Home', 
          component: Home
        },
        {
          path: '/about',
          name: 'About-us',
          component: Aboutus
        },
        {
          path: '/product/:product_id',
          name: 'Product', 
          component:Product
        },
        {
          path: '/productPdfgeneration/:product_id',
          name: 'productPdfgeneration', 
          component:ProductPdfGenearation
        },
        {
          path:'/admin/login',
          name: 'Login',
          component:Login,
        },   
        {
          path:'/admin',
          name: 'AdminDashboard',
          component:AdminDashboard,
          beforeEnter(to,from,next){
            let user = localStorage.getItem("isStatus")
            console.log("user is is is is",user)
            if(user){
              next()
            }
            else {
              next("/admin/login")
            }
          },
          children:[
            {
              path: '/productlist',
              name:'ProductList',
              component:ProductList
            },
            {
              path:'/add-category',
              name: 'AddCategory',
              component:AddCategory
            },
            {
              path:'/add-subcategory',
              name: 'AddSubCategory',
              component: AddSubCategory
            },
            {
              path:'/add-brands',
              name: 'AddBrand',
              component:AddBrands
            }
          ]
        },
        {
          path: '/admin/product/:product_id',
          name: 'AddProduct', 
          component:AddProduct,
          beforeEnter(to,from,next){
            let user = localStorage.getItem("isStatus")
            console.log("user is is is is",user)
            if(user){
              next()
            }
            else {
              next("/admin/login")
            }
          },
        },
        {
          path: '/admin/product/edit/:product_id',
          name: 'Edit Product',
          component: EditProduct,
          beforeEnter(to,from,next){
            let user = localStorage.getItem("isStatus")
            console.log("user is is is is",user)
            if(user){
              next()
            }
            else {
              next("/admin/login")
            }
          },
        },
        { 
          path: '*', 
          name: '_404', 
          component:_404
        }    
    ]
  });

export default router